import { useState } from 'react';
import Icon from './Icon';

// Polje za lozinku sa dugmetom "prikaži / sakrij"
export default function PasswordInput({ value, onChange, placeholder, autoComplete, ariaLabel, style, invalid }) {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative', marginBottom: 12 }}>
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        aria-label={ariaLabel}
        aria-invalid={invalid || undefined}
        style={{
          border: `1.5px solid ${invalid ? 'var(--red-600)' : 'var(--line)'}`, borderRadius: 10,
          padding: '12px 44px 12px 14px', fontSize: 15, width: '100%', margin: 0, ...style,
        }}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? 'Sakrij lozinku' : 'Prikaži lozinku'}
        title={show ? 'Sakrij lozinku' : 'Prikaži lozinku'}
        style={{ position: 'absolute', right: 6, top: '50%', transform: 'translateY(-50%)', width: 34, height: 34, border: 'none', background: 'transparent', color: 'var(--ink-500)', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 8 }}
      >
        <Icon name={show ? 'x' : 'eye'} size={17} />
      </button>
    </div>
  );
}
